// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__vFH3p","social-icons":"Footer_social-icons__AdRSr","col-1":"Footer_col-1__PjuSx"};